import { ShieldCheck, Lock, FileCheck2 } from "lucide-react";
import { Marquee } from "@/components/Marquee";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Welcome() {
  const signIn = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen relative flex flex-col">
      <div className="grain-overlay" />
      <div
        className="absolute inset-0 z-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1738844153732-a485f0e78382?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#070A0F]/70 via-[#070A0F]/90 to-[#070A0F]" />

      <div className="relative z-10">
        <Marquee />
      </div>

      <div className="relative z-10 flex-1 flex flex-col justify-center max-w-md mx-auto w-full px-6 py-12">
        <div className="w-12 h-12 rounded-full border border-emerald-500/50 flex items-center justify-center mb-8">
          <span className="font-serif-display text-emerald-400 text-2xl leading-none">E</span>
        </div>

        <p className="font-mono-ui text-[10px] uppercase tracking-[0.35em] text-emerald-400/80 mb-4">
          Members Only ◆ By Invitation
        </p>
        <h1 className="font-serif-display text-4xl sm:text-5xl leading-[1.05] tracking-tight text-slate-50">
          A Private Door<br />Most People<br />Never See.
        </h1>
        <p className="text-sm text-slate-400 leading-relaxed mt-6 max-w-sm">
          Complete your private intake, verify your identity, and track every stage of onboarding toward the approved
          regulated partner pathway — discreetly, from your phone.
        </p>

        <button
          onClick={signIn}
          data-testid="google-signin-button"
          className="mt-10 w-full flex items-center justify-center gap-3 bg-slate-50 text-slate-900 font-medium rounded-xl py-4 hover:bg-white transition-colors active:scale-[0.99]"
        >
          <svg className="w-5 h-5" viewBox="0 0 48 48">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
          </svg>
          Sign in with Google
        </button>

        <div className="mt-10 grid grid-cols-3 gap-3">
          {[
            { icon: Lock, label: "Encrypted" },
            { icon: ShieldCheck, label: "KYC / AML" },
            { icon: FileCheck2, label: "Written Consent" },
          ].map(({ icon: Icon, label }) => (
            <div key={label} className="flex flex-col items-center gap-2 text-center">
              <Icon className="w-4 h-4 text-emerald-400/70" strokeWidth={1.5} />
              <span className="font-mono-ui text-[9px] uppercase tracking-[0.15em] text-slate-500">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
